// src/components/CommentModal.jsx
import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import './CommentModal.css';

// Жёстко закодированные шаблоны комментариев с кодами
const STANDARD_COMMENTS = [
  { code: '023', text: 'Водитель не доставил и в диспетчерскую не звонил' },
  { code: '008', text: 'Водитель не нашел кому доставить' },
  { code: '006', text: 'Водитель не поехал на адрес' },
  { code: '004', text: 'Водитель не успел' },
  { code: '050', text: 'Водитель попал в ДТП' },
  { code: '043', text: 'водитель пропустил адрес' },
  { code: '021', text: 'Все доставлено. Снята ошибочно' },
  { code: '026', text: 'Грузчик не отгрузил' },
  { code: '058', text: 'грузчик перепутал адрес' },
  { code: '029', text: 'Доставка в позднее вечернее время' },
  { code: '048', text: 'доставлено другим рейсом' },
  { code: '003', text: 'Заведованная заявка' },
  { code: '011', text: 'Закрыто' },
  { code: '046', text: 'изменена форма оплаты, вода доставлен' },
  { code: '045', text: 'изменение кол-ва бутылей, вода доставлена' },
  { code: '034', text: 'клиент воду не заказывал' },
  { code: '014', text: 'Клиент изменил кол-во бутылок' },
  { code: '041', text: 'Клиент не ответил на телефон' },
  { code: '040', text: 'Клиент ошибся при заказе' },
  { code: '010', text: 'Клиент перенес время доставки' },
  { code: '035', text: 'клиенту не хватило воды' },
  { code: '027', text: 'логист не нашел машину вовремя' },
  { code: '056', text: 'Машина поздно вышла на рейс' },
  { code: '054', text: 'Медленный грузчик' },
  { code: '012', text: 'Менеджер дал заявку' },
  { code: '013', text: 'Не было денег у клиента' },
  { code: '001', text: 'Не было на месте' },
  { code: '022', text: 'Не было на складе воды' },
  { code: '016', text: 'Не было паспорта у водителя и грузчика' },
  { code: '028', text: 'Не было сдачи клиенту' },
  { code: '020', text: 'не было чека/накладной' },
  { code: '025', text: 'Не встретил клиент на вахте/проходной' },
  { code: '017', text: 'Не догрузили на складе воду' },
  { code: '019', text: 'Не загрузили на складе' },

  { code: '060', text: 'Не заказывали' },
  { code: '032', text: 'Не понравилась клиенту помпа' },
  { code: '007', text: 'Не понравился внешний вид бутылки' },
  { code: '005', text: 'Не пробился чек' },
  { code: '038', text: 'Не проехать' },
  { code: '018', text: 'Не работает грузовой лифт' },
  { code: '059', text: 'Не туда отдали воду' },
  { code: '030', text: 'нет кулера' },
  { code: '031', text: 'НЕТ ПРОПУСКА' },
  { code: '033', text: 'нет такой организации' },
  { code: '042', text: 'ОТКАЗ ГРУЗЧИКА ИДТИ ДО МЕСТА' },
  { code: '009', text: 'Отказ клиента' },
  { code: '049', text: 'Отсутствие пустой тары' },
  { code: '015', text: 'Ошибка 1c' },
  { code: '044', text: 'Ошибка диспетчера' },
  { code: '036', text: 'Ошибочно выбита квитанция' },
  { code: '039', text: 'Ошибочно снята' },
  { code: '037', text: 'перенос' },
  { code: '024', text: 'ПОЛОМКА АВТОМОБИЛЯ В ДОРОГЕ' },
  { code: '047', text: 'Разбилась бутылка в дороге' },
  { code: '053', text: 'т' },
  { code: '', text: '' }
];

export default function CommentModal({ isOpen, receiptId, onClose, onSelect }) {
  const [contacts, setContacts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    setError('');
    setContacts(null);

    (async () => {
      try {
        const response = await api.get(`/receipts/${receiptId}/contacts`);
        setContacts(response.data ?? response);
      } catch (e) {
        console.error(e);
        setError('Ошибка загрузки контактов');
      } finally {
        setLoading(false);
      }
    })();
  }, [isOpen, receiptId]);

  if (!isOpen) return null;

  return (
    <div className="cm-backdrop">
      <div className="cm-modal">
        <h3 className="cm-title">Контакты и комментарий</h3>

        {loading && <p>Загрузка контактов…</p>}
        {error && <p className="cm-error">{error}</p>}

        {!loading && !error && contacts && (
          <div className="cm-contacts">
            <p><b>Телефон:</b> {contacts.phone || '—'}</p>
            <p><b>Email:</b> {contacts.email || '—'}</p>
            <p><b>Комментарий доставки:</b> {contacts.delivery_comment || '—'}</p>
          </div>
        )}
<div className="cm-list-container">
        <ul className="cm-list">
          {STANDARD_COMMENTS.map(({ code, text }) => (
            <li key={code} className="cm-list-item">
              <button
                className="cm-list-btn"
                onClick={() => onSelect(`${code} - ${text}`)}
              >
                {code} - {text}
              </button>
            </li>
          ))}
        </ul>

        <button className="cm-close-btn" onClick={onClose}>Закрыть</button>
      </div>
    </div>
    </div>
  );
}
